export const launchCampaign = {
  skip: "スキップ",
  muteOn: "ミュート",
  muteOff: "ミュート解除",
  videoLabel: "キャンペーン動画",
} as const;
